import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { AccountService } from '@sm360/widget-commons-general';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';

import 'build-and-quote/components/HeaderMessage/HeaderMessage.scss';

class HeaderMessageV25 extends React.Component {
    constructor(props) {
        super(props);

        this.saveToGarage = this.saveToGarage.bind(this);
    }

    saveToGarage(newAccount) {
        if (AccountService.isAuthenticated()) {
            const { saveToGarage } = this.props;
            if (saveToGarage) {
                saveToGarage(newAccount);
            }
        }
        return true;
    }

    render() {
        const { message, saveToGarage, quote } = this.props;
        return (
            <div className="HeaderMessage--content is-bold">
                <icon className="icon-Crochet" />
                {message}
                {saveToGarage && (
                    <Quote.AddToGarageButtonV25
                        buttonClass="is-alternate"
                        quote={quote}
                        garageQuotes={this.props.garageQuotes}
                        role="button"
                        tabIndex={0}
                        onClick={this.saveToGarage}
                        hasAdobeTagging={this.props.hasAdobeTagging}
                        vehicle={this.props.vehicle}
                    />
                )}
            </div>
        );
    }
}

HeaderMessageV25.defaultProps = {
    hasAdobeTagging: false,
    vehicle: new Vehicle.VehicleModelV25(),
};

HeaderMessageV25.propTypes = {
    message: PropTypes.string.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    saveToGarage: PropTypes.func.isRequired,
    hasAdobeTagging: PropTypes.bool,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModelV25),
};

HeaderMessageV25.displayName = 'HeaderMessageV25';

function mapStateToProps(state) {
    return {
        quote: state.quoteV25,
        purchaseMethods: state.purchaseMethodsV25,
        garageQuotes: state.quotes,
    };
}

export { HeaderMessageV25 };
export default connect(mapStateToProps)(HeaderMessageV25);
